module.exports = __webpack_public_path__ + "static/media/play-circle.ce0fad93.svg";